var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fill: "#0044c6"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.256 0.00520293C11.515 0.117203 9.99999 2.0902 9.99999 2.0902C9.99999 2.0902 8.37699 -0.0237972 5.45099 0.000202816C4.33799 0.00920282 3.27799 0.476203 2.40299 1.1642C0.0189877 3.0382 -0.298012 5.0672 0.202988 7.0002H3.66699L5.39999 5.7002C5.85899 5.3562 6.51399 5.4682 6.83199 5.9452L8.24599 8.0652L9.13399 7.3992C9.47999 7.1392 9.90099 6.9992 10.334 6.9992H11.278C11.701 6.2722 12.558 5.8302 13.502 6.0612C14.222 6.2372 14.803 6.8422 14.955 7.5672C15.226 8.8612 14.246 10.0002 13 10.0002C12.262 10.0002 11.624 9.5952 11.277 9.0002H10.333L8.59999 10.3002C8.14099 10.6442 7.48599 10.5322 7.16799 10.0552L5.75399 7.9352L4.86699 8.6002C4.52099 8.8602 4.09999 9.0002 3.66699 9.0002H1.02399C2.53799 11.7642 5.30599 14.0802 6.28099 14.9902C7.31399 15.9522 8.58799 17.0952 9.34499 17.7692C9.71999 18.1032 10.279 18.1032 10.654 17.7692C11.411 17.0952 12.686 15.9522 13.718 14.9902C15.438 13.3872 22.75 7.4162 18.888 2.3122C17.779 0.845203 16.094 -0.0697971 14.256 0.00520293Z",
    fill: "#0044c6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealth);
export default __webpack_public_path__ + "static/media/Health.ad48521e26d787b36a53615c032d5557.svg";
export { ForwardRef as ReactComponent };